import req from '@sportninja/common/api/request'
import type { Account } from './index'

type ContactUpdateData = Pick<
  Account,
  'full_name' | 'title' | 'email' | 'company_name' | 'phone_number'
>

type AddressUpdateData = {
  address_street: string
  address_city: string
  address_country_id: number | undefined
  address_province_id: number | undefined
  address_postal_code: string
}

class Service {
  async updateAccount(
    id: string,
    data: Omit<
      Account,
      | 'uid'
      | 'subscription_type'
      | 'subscription'
      | 'subscription_usage'
      | 'payment_method'
      | 'subscription_upcoming_invoice'
      | 'participants'
      | 'taxes'
    >
  ) {
    const res = await req(`/account/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })

    return res.data
  }

  async updateAccountContact(id: string, data: ContactUpdateData) {
    console.log('🔄 MeService.updateAccountContact: Updating contact info')
    const res = await req(`/account/${id}/contact`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })

    return res.data
  }

  async updateAccountAddress(id: string, data: AddressUpdateData) {
    console.log('🔄 MeService.updateAccountAddress: Updating address info')
    const res = await req(`/account/${id}/address`, {
      method: 'PUT',
      body: JSON.stringify(data),
    })

    return res.data
  }
}

export const MeService = new Service()
